(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-slider"] && !Shopify.designMode) return;
  try {
    function controlFromInput(fromSlider, fromInput, toInput, controlSlider, fromHidden) {
    const [from, to] = getParsed(fromInput, toInput);
    // fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
      fromHidden.value = to;
    } else {
      fromSlider.value = from;
      fromHidden.value = from;
    }
  }

  function controlToInput(toSlider, fromInput, toInput, controlSlider, toHidden) {
    const [from, to] = getParsed(fromInput, toInput);
    // fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
    setToggleAccessible(toInput);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
      toHidden.value = to;
    } else {
      toInput.value = from;
      toHidden.value = from;
    }
  }

  function controlFromSlider(fromSlider, toSlider, fromInput, fromHidden) {
    const [from, to] = getParsed(fromSlider, toSlider);
    // fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
      fromHidden.value = to;
    } else {
      fromInput.value = from;
      fromHidden.value = from;
    }
  }

  function controlToSlider(fromSlider, toSlider, toInput, toHidden) {
    const [from, to] = getParsed(fromSlider, toSlider);
    // fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
    setToggleAccessible(toSlider);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
      toHidden.value = to;
    } else {
      toInput.value = from;
      toSlider.value = from;
      toHidden.value = from;
    }
  }

  function getParsed(currentFrom, currentTo) {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
  }

  function setToggleAccessible(currentTarget) {
    const toSlider = document.querySelector('#toSlider');
    if (Number(currentTarget.value) <= 0) {
      toSlider.style.zIndex = 2;
    } else {
      toSlider.style.zIndex = 0;
    }
  }

  // fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);

  addOnload(() => {
    any('.range_container').forEach((rc) => {
      const fromSlider = me('#fromSlider', rc);
      const toSlider = me('#toSlider', rc);
      const fromInput = me('#fromInput', rc);
      const toInput = me('#toInput', rc);
      const fromHidden = me('.min-input', rc);
      const toHidden = me('.max-input', rc);
      setToggleAccessible(toSlider);
      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput, fromHidden);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput, toHidden);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider, fromHidden);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider, toHidden);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
